<be-table [columnsToDisplay]="columns" [modelType]="model" [allowEdition]="canEdit"
          [allowRemoval]="canRemove"></be-table>
